module.exports = __webpack_public_path__ + "img/certificate5.ed6be18a.png";